import * as React from "react";
import {
  List,
  Datagrid,
  TextField,
  EditButton
} from "react-admin";

export default function Assets(props) {
  return (
    <List {...props} title="Assets">
      <Datagrid rowClick="edit">
        <TextField source="id" />
        <TextField source="name" />
        <TextField source="src" />
        <EditButton />
      </Datagrid>
    </List>
  );
}
